import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { 
    Modal, 
    Box, 
    Typography, 
    Button, 
    Stack,
    Card,
    CardContent,
    CardActions,
    Divider,
    Grid
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { searchNotifications } from '../../store/callcenter/CallCenterSlice';
import notificationSound from '../../sound/BildirimSesi.mp3'; // yolunu kendi dosya yapınıza göre ayarlayın

// Tarih formatlama ve zaman hesaplama fonksiyonu
const formatDateTime = (dateString) => {
    if (!dateString) return '';

    const date = new Date(dateString);
    const now = new Date();
    const diffMs = now - date;
    const diffMins = Math.floor(diffMs / 60000);
    const diffHours = Math.floor(diffMins / 60);
    const diffDays = Math.floor(diffHours / 24);

    // Türkçe tarih formatı
    const formattedDate = date.toLocaleDateString('tr-TR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
    });

    // Geçen süre kontrolü
    let timeText = '';
    if (diffMins < 1) {
        timeText = '(Az önce)';
    } else if (diffMins < 60) {
        timeText = `(${diffMins} dakika önce)`;
    } else if (diffHours < 24) {
        timeText = `(${diffHours} saat önce)`;
    } else if (diffDays < 7) {
        timeText = `(${diffDays} gün önce)`;
    }

    return {
        formattedDate,
        timeText,
        isOverdue: diffMins > 10 // 10 dakikayı geçmiş mi kontrolü
    };
};

const NotificationAlert = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [open, setOpen] = useState(false);
    const [notifications, setNotifications] = useState([]);
    
    // Ses çalma fonksiyonu
    const playNotificationSound = () => {
        const audio = new Audio(notificationSound);
        audio.play();
    };

    const checkNewNotifications = async () => {
        // localStorage kontrolü
        const isNoticeActive = localStorage.getItem('selectedNotice') === 'active';
        if (!isNoticeActive) return;

        const now = new Date();
        const yesterday = new Date(now);
        yesterday.setDate(yesterday.getDate() - 1);

        try {
            const result = await dispatch(searchNotifications({
                mtState: 0,
                // dtStart: yesterday.toISOString(),
                // dtFinish: now.toISOString()
            })).unwrap();

            if (result && result.length > 0) {
                setNotifications(result);
                setOpen(true);
                playNotificationSound(); // Yeni bildirim varsa sesi çal
            }
        } catch (error) {
            console.error('Bildirim kontrolü hatası:', error);
        }
    };

    useEffect(() => {
        // İlk kontrol
        checkNewNotifications();

        // Her 30 saniyede bir kontrol et
        const interval = setInterval(checkNewNotifications, 30 * 1000);

        return () => clearInterval(interval);
    }, []);

    const handleClose = () => {
        setOpen(false);
    };

    const handleNavigateToNotice = () => {
        navigate('/apps/notice-list');
        setOpen(false);
    };

    if (!notifications.length) return null;

    return (
        <Modal
            open={open}
            disableEscapeKeyDown
            disableBackdropClick
            aria-labelledby="notification-modal-title"
        >
            <Box sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: '80%',
                maxWidth: 600,
                bgcolor: 'background.paper',
                boxShadow: 24,
                p: 4,
                borderRadius: 1,
                maxHeight: '90vh',
                overflow: 'auto'
            }}>
                <Typography id="notification-modal-title" variant="h6" component="h2" gutterBottom>
                    Yeni İhbarlar ({notifications.length})
                </Typography>
                <Divider sx={{ mb: 2 }} />
                
                <Stack spacing={2}>
                    {notifications.map((notification) => {
                        const dateInfo = formatDateTime(notification.dtDate);
                        return (
                            <Card key={notification.idNotification} variant="outlined">
                                <CardContent>
                                    <Typography variant="h6" color="primary" gutterBottom>
                                        {notification.dsCompanyName}
                                    </Typography>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12}>
                                            <Typography variant="body1">
                                                <strong>İhbarı Oluşturan:</strong> {notification.dsNameSurname || 'Bayi'}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Typography variant="body1">
                                                <strong>Bayi:</strong> {notification.dsDealerName}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Typography variant="body1">
                                                <strong>Açıklama:</strong> {notification.dsDescription}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Typography variant="body2" color="text.secondary">
                                                İhbar No: {notification.idNotification}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Typography 
                                                variant="body2" 
                                                color={dateInfo.isOverdue ? 'error' : 'text.secondary'}
                                                sx={{ 
                                                    fontWeight: dateInfo.isOverdue ? 'bold' : 'normal',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: 1
                                                }}
                                            >
                                                İhbar Tarihi: {dateInfo.formattedDate} {dateInfo.timeText}
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </CardContent>
                                <CardActions>
                                    <Button 
                                        size="small" 
                                        onClick={handleNavigateToNotice}
                                        variant="contained"
                                    >
                                        İhbara Git
                                    </Button>
                                </CardActions>
                            </Card>
                        );
                    })}
                </Stack>

                <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end' }}>
                    <Button onClick={handleClose} variant="outlined">
                        Tamam
                    </Button>
                </Box>
            </Box>
        </Modal>
    );
};

export default NotificationAlert; 